// extracted by mini-css-extract-plugin
export default {"info_container":"ModelMenu_info_container__DhDUX","no_item_container":"ModelMenu_no_item_container__BmI7n","info_field_container":"ModelMenu_info_field_container__+bKv1"};